import * as React from "react";
import { GameTypeEnum } from "../../../enums";
import { useAppSelector } from "../../../store/hooks";

import InfoBox from "./InfoBox";
import InfoBoxSmall from "./InfoBoxSmall";

interface IProps {
  showHistory: boolean;
}
const InfoBoxesHolder: React.FC<IProps> = ({ showHistory }) => {
  const pickedStakes = useAppSelector((state) => state.picks.pickedStakes);
  const pickingHistory = useAppSelector((state) => state.picks.pickingHistory);
  const showPicks = useAppSelector((state) => state.picks.shouldShowYourPick);
  const gameType = useAppSelector((state) => state.config.gameType);

  return (
    <div className="bet_info_box">
      {!showHistory && (
        <InfoBox
          title="panel.common.yourPick"
          content={pickedStakes.map((el) => el.value)}
          shouldShow={showPicks}
        />
      )}

      <InfoBoxSmall />

      {showHistory && (
        <InfoBox
          title={`${
            gameType === GameTypeEnum.ONLINE
              ? "panel.bettingPanel.history"
              : "panel.bettingPanel.lastPick"
          }`}
          content={pickingHistory}
          shouldShow
        />
      )}
    </div>
  );
};

export default InfoBoxesHolder;
